// CallButton.js
import { logEvent } from '../../api';
import { getUserId } from '../../services/AuthService';

const CallButton = ({ phoneNumber, clientId }) => {
  const isMobile = window.innerWidth <= 768;

  const handleClick = async () => {
    if (isMobile) {
      window.location.href = `tel:${phoneNumber}`;
    } else {
      alert('Esta funcionalidad solo está disponible en móvil');
      return;
    }

    try {
      await logEvent({
        EventTypeId: 3,                          // 3 = llamada
        UserId:      getUserId(),                // quien llama
        Entity:      'clients',              // entidad genérica
        EntityId:    clientId,                // usamos el propio número como ID
        Timestamp:   new Date().toISOString(),
        Payload:     JSON.stringify({ phoneNumber }),
        IndexRoute:  window.location.pathname
      });
    } catch (err) {
      console.error('Error al loguear llamada:', err);
    }
  };

  return (
    <button onClick={handleClick}>
      Llamar a {phoneNumber}
    </button>
  );
};

export default CallButton;
